import { Injectable } from '@angular/core';
import { LoggerService } from './logger.model';

@Injectable()
export class DefaultLoggerService implements LoggerService {
  trace(...messages: unknown[]): void {
    console.trace.apply(null, messages);
  }

  debug(...messages: unknown[]): void {
    console.debug.apply(null, messages);
  }

  log(...messages: unknown[]) {
    console.log.apply(null, messages);
  }

  warn(...messages: unknown[]) {
    console.warn.apply(null, messages);
  }

  error(...messages: unknown[]) {
    console.error.apply(null, messages);
  }
}
